export default (Vue) => {
    return {
        //给嵌入页面发送自定义广播事件
        emit(type,msg){
            Vue.prototype.$eventBus.emit('IframeMsg',{
                type: '__broadcast',
                msg: {
                    type,
                    msg
                }
            })
        },
        do(type,msg){
            Vue.prototype.$eventBus.emit('HandleIframeMsg',{
                type,
                msg
            })
        }
    }
}